import axios from "axios";

// ✅ Load environment variables
const API_BASE_URL = "https://api.countrystatecity.in/v1";
const API_KEY = process.env.REACT_APP_CSC_API_KEY; // 🔑 .env se API key le rahe hain


const countryStateApiInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { "X-CSCAPI-KEY": API_KEY },
});

export default countryStateApiInstance;
